/* eslint-disable @typescript-eslint/no-explicit-any */
import { Children, Component } from 'react';
import { RouteComponentProps } from 'react-router';

export type ChangeRouteFn = (arg0: string, supress?: boolean) => void;
export type ReplaceRouteFn = (arg0: string) => void;

type Props = RouteComponentProps & {
  children: (
    isBlocking: boolean,
    changeRoute: ChangeRouteFn,
    replaceRoute: ReplaceRouteFn,
  ) => React.ReactNode;
};

type State = {
  isBlocking: boolean;
};

/*
  BlockTransition component is used to provide a way to block or
  prompt the user before transitioning to a different route.
*/
// TODO: Check whether we need to replace CustomEvent with something else or not.
export class BlockTransition extends Component<Props, State> {
  state: State = {
    isBlocking: false,
  };

  render() {
    let { isBlocking } = this.state;
    return Children.only(
      this.props.children(isBlocking, this._changeRoute, this._replaceRoute),
    );
  }

  _changeRoute = (routePath: string, suppressPrompt?: boolean) => {
    let { location, history } = this.props;
    if (location.pathname !== routePath) {
      let hasCompleted = false;
      this._startBlocking();
      if (!suppressPrompt) {
        let event: CustomEvent & ObjectOf<any> = new CustomEvent(
          'routeChange',
          { cancelable: true },
        );
        event.routePath = routePath;
        // This allows us to cancel the route change and optionally continue it
        // later (after showing a dialog).
        event.proceed = () => {
          if (!hasCompleted) {
            this._changeRoute(routePath, true);
          }
        };
        document.dispatchEvent(event);
        if (event.defaultPrevented) {
          return;
        }
        this._stopBlocking();
        hasCompleted = true;
      }
      history.push(routePath);
    }
  };

  _replaceRoute = (routePath: string) => {
    let { location, history } = this.props;
    if (location.pathname !== routePath) {
      history.replace(routePath);
    }
  };

  _startBlocking = () => this.setState({ isBlocking: true });
  _stopBlocking = () => this.setState({ isBlocking: false });
}
